import {
    StatisticalProfilePodResource,
    StatisticalProfilePodResourceType,
    StatisticalProfileResource,
    StatisticalProfileResourceType
} from './statistical-profile/statistical-profile.component';
import {PodStatisticalProfileRequestPlant} from 'smag-commons/dto/api/profiles';
import {RateMode} from 'smag-commons/cfg';

export function isPvPlant(resource: StatisticalProfileResource) {
    return resource.type === StatisticalProfileResourceType.PV_PLANT;
}

export function isWindPlant(resource: StatisticalProfileResource) {
    return resource.type === StatisticalProfileResourceType.WIND_PLANT;
}

export function isPlant(resource: StatisticalProfileResource) {
    return isPvPlant(resource) || isWindPlant(resource);
}

export function isProducer(resource: StatisticalProfileResource) {
    return resource.type === StatisticalProfileResourceType.POD &&
        (resource as StatisticalProfilePodResource).podType === StatisticalProfilePodResourceType.PRODUCER;
}

export function isConsumer(resource: StatisticalProfileResource) {
    return resource.type === StatisticalProfileResourceType.POD &&
        (resource as StatisticalProfilePodResource).podType === StatisticalProfilePodResourceType.CONSUMER;
}

export function isProsumer(resource: StatisticalProfileResource) {
    return resource.type === StatisticalProfileResourceType.POD &&
        (resource as StatisticalProfilePodResource).podType === StatisticalProfilePodResourceType.PROSUMER;
}

export function getRateMode(profiles: PodStatisticalProfileRequestPlant[]) {
    if (profiles.length === 0) {
        return RateMode.SINGLE;
    }
    const referenceRateMode = profiles[0].profile.rate_mode;
    const allMatch = profiles.every(p => p.profile.rate_mode === referenceRateMode);
    return allMatch ? referenceRateMode : RateMode.SINGLE;
}


